import { render, staticRenderFns } from "./WhatifOverview.vue?vue&type=template&id=493f4a56&scoped=true&"
import script from "./WhatifOverview.vue?vue&type=script&lang=js&"
export * from "./WhatifOverview.vue?vue&type=script&lang=js&"
import style0 from "./WhatifOverview.vue?vue&type=style&index=0&id=493f4a56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f4a56",
  null
  
)

export default component.exports